export const COPY_LANGUAGES = [
  { value: "pt", label: "Português (BR)" },
  { value: "en", label: "English" },
  { value: "es", label: "Español" },
] as const

export type CopyLanguage = (typeof COPY_LANGUAGES)[number]["value"]

export const RECURRING_TIMEZONES = [
  { value: "America/Sao_Paulo", label: "Brasília (BRT)" },
  { value: "America/New_York", label: "Nova York (ET)" },
  { value: "America/Chicago", label: "Chicago (CT)" },
  { value: "America/Denver", label: "Denver (MT)" },
  { value: "America/Los_Angeles", label: "Los Angeles (PT)" },
  { value: "America/Argentina/Buenos_Aires", label: "Buenos Aires (ART)" },
  { value: "Europe/Lisbon", label: "Lisboa (WET)" },
  { value: "Europe/Madrid", label: "Madrid (CET)" },
  { value: "UTC", label: "UTC" },
] as const

export type RecurringTimezone = (typeof RECURRING_TIMEZONES)[number]["value"]

export const DEFAULT_TIMEZONE: RecurringTimezone = "America/Sao_Paulo"
export const DEFAULT_COPY_LANGUAGE: CopyLanguage = "pt"

export function copyLanguageLabel(value: string | undefined | null): string {
  return COPY_LANGUAGES.find((l) => l.value === value)?.label ?? "Português (BR)"
}

export function timezoneLabel(value: string | undefined | null): string {
  return RECURRING_TIMEZONES.find((tz) => tz.value === value)?.label ?? value ?? DEFAULT_TIMEZONE
}

export function timezoneAbbreviation(timezone: string): string {
  try {
    const parts = new Intl.DateTimeFormat("pt-BR", {
      timeZone: timezone,
      timeZoneName: "short",
    }).formatToParts(new Date())
    return parts.find((p) => p.type === "timeZoneName")?.value ?? timezone
  } catch {
    return timezone
  }
}
